// extracted by mini-css-extract-plugin
module.exports = {"input":"_3cTpS","password":"_12Z7H","secured":"_2Hxd2","wrapper":"_3RAF_","fullWidth":"_3qhuf","switcher":"FHxd7","flasher":"_3GXQK"};